import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

import { itemVariantSerializer } from "./items";

export const shopifyProductVariantSerializer = Serializers.object({
  variantId: Serializers.string,
  sku: Serializers.string,
  productId: Serializers.string,
  variant: itemVariantSerializer,
  barcode: Serializers.string.optional({ emptyStrAsUndefined: true }),
  weightKg: Serializers.float,
});

export type ShopifyProductVariant = SerializerValue<typeof shopifyProductVariantSerializer>;

export const shopifyProductSerialzier = Serializers.object({
  id: Serializers.string,
  title: Serializers.string,
  description: Serializers.string,
  vendor: Serializers.string,
  handle: Serializers.string,
  tags: Serializers.string.array(),
});

export type ShopifyProduct = SerializerValue<typeof shopifyProductSerialzier>;

export const bcItemSerializer = Serializers.object({
  bcId: uuidSerializer.nullable(),
  itemId: Serializers.string,
  itemName: Serializers.string,
  gtin: Serializers.string.optional({ emptyStrAsUndefined: true }),
});

export type BcItem = SerializerValue<typeof bcItemSerializer>;
